import { ComponentFactoryResolver, ViewChild, ViewContainerRef, EventEmitter, ChangeDetectorRef, Directive } from "@angular/core";

import { WizardComponent } from "../../wizard.component";
import { UserWizardService } from "../../services/user/user.wizard.service";
import { ActivatedRoute } from "@angular/router";
import {Subscription} from "rxjs";
import { get } from 'lodash';

@Directive()
export abstract class UserWizardComponent extends WizardComponent {
  wizardService: UserWizardService;
  changeDetectorRef: ChangeDetectorRef;
  activatedRoute: ActivatedRoute;

  wizardConfig: any;
  wizardId: string;
  queryParams: any;
  onClose = new EventEmitter<any>();
  activatedRouteSubscription: Subscription;

  @ViewChild("contentPlaceholder", { read: ViewContainerRef,
static: true })
  contentRef: ViewContainerRef;
  @ViewChild("subContentPlaceholder", { read: ViewContainerRef,
static: true })
  subContentRef: ViewContainerRef;

  constructor(
    wizardService: UserWizardService,
    changeDetectorRef: ChangeDetectorRef,
    activatedRoute: ActivatedRoute,
    private readonly factoryResolver: ComponentFactoryResolver
  ) {
    super();
    this.wizardService = wizardService;
    this.changeDetectorRef = changeDetectorRef;
    this.activatedRoute = activatedRoute;
  }

  ngOnInit() {
    this.activatedRouteSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.queryParams = params;
      const defaultParams = JSON.parse(get(this.queryParams, 'defaultParams', "{}"));
      this.wizardService.openWizard(this.wizardId, this.wizardConfig, defaultParams);
      this.wizardService.registerToggleListener(this.notifyOnToggleSubContent.bind(this));
    });
  }

  ngAfterViewInit() {
    this.createContentComponent();
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if(this.activatedRouteSubscription) {
      this.activatedRouteSubscription.unsubscribe();
    }
  }

  //-------------- Control && Validation -----------------------
  toggleNext() {
    this.wizardService.nextStep();
    this.createContentComponent();
  }

  toggleBack() {
    this.wizardService.previousStep();
    this.createContentComponent();
  }

  toggleFinish() {
    const result = this.wizardService.onFinish();
    result.subscribe((outcome) => {
      this.createContentComponent()
    });
  }

  toggleClose() {
    this.wizardService.toggleClose(
      () => this.onClose.emit(true)
    );
  }

  toggleReOpen() {
    this.wizardService.reOpen();
  }

  notifyOnToggleSubContent(onOff) {
    if (onOff) {
      this.createSubContentComponent();
    }
    else {
      this.subContentRef.clear();
    }
  }

  getWizardService() {
    return this.wizardService;
  }

  getFactoryResolver() {
    return this.factoryResolver;
  }

  getContentViewRef() {
    return this.contentRef;
  }

  getSubContentViewRef() {
    return this.subContentRef;
  }

  abstract resolveComponentType(templateId);
}
